export const checkFilter = (object, attachConfig) => {
  if (!attachConfig.filter) return true
  if (!object) return false
  const field = attachConfig.filter.field
  const value = attachConfig.filter.value
  if (!field) return true
  return !(!object[field] || value.indexOf(object[field]) < 0)
}

export const getAttachByCategory = (object, category) => {
  if(object) {
    const array = Array.isArray(object) ? object : object.attachments
    if (array && array.length > 0) {
      const list = array.filter(item => item.category === category)
      return list && list.length > 0 ? list : null
    }
  }
  return null
}
